import {connect} from 'react-redux';
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Bar from '../../../ui/Bar';
import Button from '../../../ui/Button';
import {FormattedMessage} from 'react-intl';
import ImmutablePropTypes from 'react-immutable-proptypes';
import ProfileInfo from './ProfileInfo';
import styles from './css/ProfileDetails.scss';

export class Profile extends Component {
    static propTypes = {
        children: PropTypes.node,
        session: ImmutablePropTypes.map.isRequired,
    };

    render() {
        const {session} = this.props;
        const userData = session.get('user');
        return (
            <div className={styles.profile}>
                <Bar>
                    <ProfileInfo user={userData}/>
                </Bar>
                <Bar>
                    <Button emphasis='default' link href='/api/v1/locations/export'>
                        <FormattedMessage id='frontend.settings.button.export_profile'/>
                    </Button>
                    <Button link to={`/settings/deactivate`} emphasis='warning'>
                        <FormattedMessage id='frontend.settings.button.deactivate_profile'/>
                    </Button>
                </Bar>
            </div>
        );
    }
}

export default connect(state => ({
    session: state.session,
}))(Profile);
